module.exports = __webpack_public_path__ + "static/media/funnelIcon.272ba0a9.svg";